interface CardValidationError {
     errorCode: string;
     errorMessage: string;
}

export const cardValidationError: Record<string, CardValidationError> = {
     incomplete_cvc: { errorCode: "incomplete_cvc", errorMessage: "You have entered incomplete CVV/CVC." },
     incomplete_date: { errorCode: "incomplete_date", errorMessage: "You have entered incomplete date." },
     date_in_past: { errorCode: "date_in_past", errorMessage: "You have entered date in the past." },
     invalid_expiration_year: { errorCode: "invalid_expiration_year", errorMessage: "You have entered invalid year." },
     incomplete_card_number: { errorCode: "incomplete_card_number", errorMessage: "You have entered incomplete card number." },
     incorrect_card_number: { errorCode: "incorrect_card_number", errorMessage: "You have entered incorrect card number." }
};

export const transactionStatus = {
     approved: 'APPROVED',
     pending: 'PENDING'
}

export const transactionCategory = {
     payment: 1
}

export const transactionSubCategory = {
     payment: 1,
     refund: 2,
     void: 3
}
